import styled from "styled-components";
import FontAwesomeIcon from "@streeteasy/design-system/deprecated/Icons/FontAwesomeIcon";
import Modal from "@streeteasy/design-system/deprecated/Modal";
import Text from "@streeteasy/design-system/deprecated/Text";
import Title from "@streeteasy/design-system/deprecated/Title";

const SuccessIcon = styled(FontAwesomeIcon).attrs({
  color: "primary",
  iconClass: "check",
  fontSize: "32px"
})`
  align-items: center;
  align-self: center;
  display: flex;
  font-size: ${props => (props.layout === "default" ? "32px" : "24px")};
  height: 32px;
  justify-content: center;
  margin: ${props => (props.layout === "default" ? "0 0 35px" : "0 15px 0 0")};
  padding: 0;
  width: 32px;

  @media (max-width: 479px) {
    margin: 0 auto 25px;
  }
`;

const ModalContent = styled.div`
  align-items: center;
  background: white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  min-height: 400px;
  min-width: 480px;

  @media (max-width: 479px) {
    min-height: 320px;
    min-width: initial;
    width: 320px;
  }
`;

const ModalFooter = styled.div`
  margin-top: auto;
  padding: 40px 0;
  text-align: center;

  @media (max-width: 479px) {
    padding: 45px 0;
  }
`;

const ModalTitle = styled(Title).attrs({
  type: "primarySm"
})`
  margin-bottom: ${props => (props.layout === "default" ? "15px" : "0")};
  max-width: 312px;
  padding: 0;
  text-align: ${props => (props.layout === "default" ? "center" : "left")};

  @media (max-width: 479px) {
    font-size: 22px;
    margin-bottom: ${props => (props.layout === "default" ? "25px" : "0")};
    max-width: 220px;
  }
`;

const ModalText = styled(Text).attrs({
  type: "sm"
})`
  margin: ${props => (props.layout === "default" ? "0" : "15px 0 0")};
  max-width: 312px;
  text-align: center;

  @media (max-width: 479px) {
    margin-top: ${props => (props.layout === "default" ? "0" : "25px")};
    max-width: 220px;
  }
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: ${props => (props.layout === "default" ? "column" : "row")};
  flex-wrap: wrap;
  justify-content: center;
  margin: ${props => (props.layout === "default" ? "108px" : "75px")} 0 30px;
  max-width: 312px;

  @media (max-width: 479px) {
    flex-direction: column;
    margin-bottom: ${props => (props.layout === "default" ? "0" : "30px")};
    margin-top: 55px;
  }
`;

const CustomContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
`;

const SuccessMessageModal = styled(Modal)`
  [aria-modal="true"] {
    @media (max-width: 479px) {
      left: 50%;
      margin: auto;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;

export {
  CustomContent,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalTitle,
  ModalText,
  SuccessIcon,
  SuccessMessageModal
};
